/* eslint-disable max-len */
import RestService from '../services/rest';

async function getPurchaseReport(initialDate, finalDate) {
  const response = await RestService.getAuthenticated(`panel/report/purchase?initialDate=${initialDate}&finalDate=${finalDate}`, {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'purchase-report.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
  return response;
}

export default {
  getPurchaseReport,
};
